import { render, staticRenderFns } from "./AdminCategoryImages.vue?vue&type=template&id=95a76468&scoped=true"
import script from "./AdminCategoryImages.vue?vue&type=script&lang=js"
export * from "./AdminCategoryImages.vue?vue&type=script&lang=js"
import style0 from "./AdminCategoryImages.vue?vue&type=style&index=0&id=95a76468&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95a76468",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a76468')) {
      api.createRecord('95a76468', component.options)
    } else {
      api.reload('95a76468', component.options)
    }
    module.hot.accept("./AdminCategoryImages.vue?vue&type=template&id=95a76468&scoped=true", function () {
      api.rerender('95a76468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminCategoryImages.vue"
export default component.exports